import * as c from "./SelectManyItem.module.css";

interface SelectManyItemProps {
  value: string;
  isSelected: boolean;
  onToggle: () => void;
  usedInMore: boolean;
}

function SelectManyItem({ value, isSelected, onToggle, usedInMore }: SelectManyItemProps) {
  return (
    <div
      className={`${usedInMore ? c["select-many-container-more"] : c["select-many-container"]} ${
        isSelected ? (usedInMore ? c["selected-more"] : c["selected"]) : ""
      } `}
    >
      <input
        type="checkbox"
        id={`checkbox_for_${value}`}
        value={value}
        checked={isSelected}
        onChange={onToggle}
      />
      <label htmlFor={`checkbox_for_${value}`}>{value}</label>
    </div>
  );
}

export default SelectManyItem;
